import {
  blacklistedPages,
  NEWSLETTER_MODAL_ID,
} from 'shared/experiments/browser/newsletterModal/consts'
import mountNewsletterModalContainer from 'shared/experiments/components/NewsletterModal/mountNewsletterModalFormContainer'

export const NEWSLETTER_MODAL_WAIT_TIME = 7000

const setHashSilently = (hash: string) => {
  const url = new URL(window.location.href)
  url.hash = hash.startsWith('#') ? hash : `#${hash}`
  history.replaceState(null, '', url.toString())
}

const clearHashSilently = () => {
  const url = new URL(window.location.href)
  url.hash = ''
  history.replaceState(null, '', url.toString())
}

const modalClickHandler = (e: MouseEvent) => {
  const target = e.target as Element
  const closer = target.closest('[data-a11y-dialog-hide]')
  if (closer && window.location.hash === `#${NEWSLETTER_MODAL_ID}`) {
    clearHashSilently()
    const newsletterModal = document.getElementById(NEWSLETTER_MODAL_ID)
    newsletterModal?.removeEventListener('click', modalClickHandler, true)
  }
}

const modalHideObserver = (modalElement: HTMLElement) => {
  const observer = new MutationObserver(() => {
    if (modalElement.getAttribute('aria-hidden') === 'true') {
      if (window.location.hash === `#${NEWSLETTER_MODAL_ID}`)
        clearHashSilently()
      observer.disconnect()
      modalElement.removeEventListener('click', modalClickHandler, true)
    }
  })
  observer.observe(modalElement, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
  })
}

export const triggerNewsletterModal = () => {
  setTimeout(async function () {
    setHashSilently(NEWSLETTER_MODAL_ID)

    window.localStorage.setItem(NEWSLETTER_MODAL_ID, 'true')
    await mountNewsletterModalContainer()

    const newsletterModal = document.getElementById(NEWSLETTER_MODAL_ID)
    if (newsletterModal) {
      newsletterModal.addEventListener('click', modalClickHandler, true)
      modalHideObserver(newsletterModal)
    }

    const virtualPath = `${window.location.pathname}/__${NEWSLETTER_MODAL_ID}`
    window._uxa = window._uxa || []
    window._uxa.push(['trackPageview', virtualPath])
  }, NEWSLETTER_MODAL_WAIT_TIME)
}

export const getIsSourceBlacklisted = (page: string, searchUrl?: string) => {
  if (
    !searchUrl ||
    searchUrl.includes('newsletter=ch') ||
    searchUrl.includes('newsletter=fr') ||
    blacklistedPages.includes(page)
  )
    return true

  return (
    searchUrl.includes('adword=google/S_de-CH_Branded_Exact/Brand_exact') ||
    searchUrl.includes('adword=google/S_fr-CH_Branded_Exact/Brand_exact') ||
    searchUrl.includes('adword=google/S_de-CH_Branded/Gen_Shop-Apotheke')
  )
}
